import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home, RefreshCcw } from "lucide-react";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-8">
        {/* 404 Illustration/Number */}
        <div className="relative">
          <h1 className="text-9xl font-bold text-gray-200">404</h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-2xl font-semibold text-gray-800">Page Not Found</span>
          </div>
        </div>

        {/* Message */}
        <div className="space-y-3">
          <p className="text-gray-600">
            Oops! The page you're looking for seems to have wandered off.
          </p>
          <p className="text-sm text-gray-500">
            It might have been moved, deleted, or never existed in the first place.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="space-y-3">
          <Button
            variant="default"
            className="w-full"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>

          <div className="flex gap-3">
            <Button
              variant="outline"
              className="flex-1"
              onClick={() => navigate("/")}
            >
              <Home className="mr-2 h-4 w-4" />
              Home
            </Button>
            
            <Button
              variant="outline"
              className="flex-1"
              onClick={() => window.location.reload()}
            >
              <RefreshCcw className="mr-2 h-4 w-4" />
              Refresh
            </Button>
          </div>
        </div>

        {/* Support Link */}
        <p className="text-sm text-gray-500">
          Need help? {" "}
          <a
            href="mailto:support@willtheyconvert.com"
            className="text-amber-600 hover:text-amber-700 underline"
          >
            Contact our support team
          </a>
        </p>
      </div>
    </div>
  );
};

export default NotFound;
